import { render } from "./PlanetInfo.vue?vue&type=template&id=13040f43&scoped=true"
import script from "./PlanetInfo.vue?vue&type=script&lang=ts"
export * from "./PlanetInfo.vue?vue&type=script&lang=ts"

import "./PlanetInfo.vue?vue&type=style&index=0&id=13040f43&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-13040f43"

export default script